"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _button = _interopRequireDefault(require("../button"));

var _ModalComponent = _interopRequireDefault(require("./ModalComponent"));

var _Text = _interopRequireDefault(require("../Text"));

require("./ModalComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_ModalComponent["default"].Icon = function (_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "modal-logo"
  }, children);
};

_ModalComponent["default"].H1 = function (_ref2) {
  var children = _ref2.children,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? "sub-heading-text-two headingColor" : _ref2$className;
  return /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    className: "text-center ".concat(className)
  }, children);
};

_ModalComponent["default"].Text = function (_ref3) {
  var children = _ref3.children,
      className = _ref3.className;
  return /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    className: "text-center base ".concat(className)
  }, children);
};

_ModalComponent["default"].Proceed = function (_ref4) {
  var onClick = _ref4.onClick,
      className = _ref4.className,
      children = _ref4.children,
      _ref4$type = _ref4.type,
      type = _ref4$type === void 0 ? "primary" : _ref4$type,
      _ref4$htmlType = _ref4.htmlType,
      htmlType = _ref4$htmlType === void 0 ? "submit" : _ref4$htmlType,
      loading = _ref4.loading,
      disabled = _ref4.disabled;
  return /*#__PURE__*/_react["default"].createElement(_button["default"], {
    className: className,
    onClick: onClick,
    type: type,
    htmlType: htmlType,
    loading: loading,
    disabled: disabled
  }, children || t("modal.ok"));
};

_ModalComponent["default"].Cancel = function (_ref5) {
  var onClick = _ref5.onClick,
      children = _ref5.children,
      className = _ref5.className,
      type = _ref5.type,
      loading = _ref5.loading;
  return /*#__PURE__*/_react["default"].createElement(_button["default"], {
    className: className,
    onClick: onClick,
    type: type || "secondary",
    loading: loading
  }, children || t("modal.cancel"));
};

var _default = _ModalComponent["default"];
exports["default"] = _default;